import { Component, Inject, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { Subscription } from 'rxjs';
import {MessengerService} from '../../services/messenger.service';
import { DialogButtonComponent } from "../buttons/dialog-button.component";

@Component({
  standalone: true,
  imports: [DialogButtonComponent],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-2xl w-full">
      <div class="p-6 w-96 max-w-full">
        <h2 class="text-xl font-bold mb-4">{{ modalData?.title }}</h2>
        <p [innerHTML]="modalData?.message"></p>
        <div class="mt-4 flex gap-2 justify-end">
          <app-dialog-button
            [text]="modalData?.abortText || 'Avbryt'"
            (onClick)="close(false)">
          </app-dialog-button>
          <app-dialog-button
            [text]="modalData?.confirmText || 'Bekräfta'"
            [disabled]="isWorking"
            (onClick)="confirm()"
            variant="primary">
          </app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class ChangeDtDialogComponent {
  modalData?: {
    title: string;
    message: string;
    confirmText?: string;
    abortText?: string;
    action?: string;
  };

  isWorking = false;

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: any,
  ) {
    this.modalData = data;
  }

  confirm(): void {
    this.close(true);
  }
  
  close(value: any = false): void {
    this.modalService.close(value);
  }

}
